/**
 * The color in this enum is strictly 1:1 mapped with our styleguide colors https://app.zeplin.io/project/5c2f5293b98707af9561727d/styleguide/colors
 * Do not add any colors here which are not in the styleguide.
 * If there are any colors used in the designs which are not part of the styleguide, do
 *  1) Challenge the design team to use only the colors in styleguide
 *  2) Use inline style so that we don't create a color variable for an unconventional color in the design
 */
export enum COLORS {
  Black = '#000000',
  Grey0 = '#6b6b6b',
  Grey1 = '#9b9b9b',
  Grey2 = '#cccccc',
  Grey3 = '#e5e5e5',
  Grey4 = '#f2f2f2',
  Grey5 = '#f8f8f8',
  Grey6 = '#838383',
  Grey7 = '#e2e2e2',
  White = '#ffffff',
  Orange = '#fabf9c',
  Yellow = '#ffe899',
  YellowGold = '#ffb402',
  NeonYellow = '#f9ff00',
  HighlightRed = '#e75714',
  Green = '#70eab4',
  Red = '#ff5a5a',
  RedSale = '#e72d34',
  Blue4 = '#513edc',
  Green2 = '#76d492',
  Green3 = '#029963',
  GreenNeon = '#CBF85E',
  DarkGreen = '#3B5512',
  StartGradientSale = '#e72d34',
  EndGradientSale = '#ffa31a',
  PersonalDiscount = '#FF5400',
  ProductImageBackground = '#f4f4f5',
  PrimaryCoupon = '#1539CF',
  BackgroundCoupon = '#E3ECF8',
  BorderColorCoupon = '#A1B0EC',
  TertiaryCoupon = '#4075FF',
  LavenderBlush = '#FFF1F1',
  LightSalmonPink = '#FFA0A0',
}

export const DISCOUNT_SALE_GRADIENT = `linear-gradient(37deg, ${COLORS.StartGradientSale} 0%, ${COLORS.EndGradientSale} 100%)`;
